import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import SendIcon from '@mui/icons-material/Send';
import PropTypes from 'prop-types';
import {
  Button,
  ListSubheader,
  List,
  Grid,
  Tabs,
  Tab,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  OutlinedInput,
  Stack,
  Box,
  useTheme,
  TextField,
  styled,
  Dialog,
  Typography,
  Divider,
  Container,
  Snackbar,
  DialogTitle,
  DialogContent,
  DialogActions,
  CardMedia,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import APPlatestaccstatus from './APPlatestaccstatus';
import Applatestmovingstatus from './Applatestmovingstatus';
import APPlatestcamerastatus from './APPlatestcamerastatus';
import Applatestonlinetime from './Applatestonlinetime';

// ----------------------------------------------------------------------

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  },
  '.css-12wq9jj-MuiPaper-root-MuiDialog-paper': {
    width: '100%',
    height: '100%'
  }
}));
// -----------------按鈕-------------
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

export default function BootpDialog(props) {
   // eslint-disable-next-line prefer-const
  let intervalId = null;
  // eslint-disable-next-line prefer-const
  let token = '';
  const host =localStorage.getItem('apiurl');
  const dvrhost = 'https://myfleet.api.dev.theomnieyes.com/';
  const [Vehicleobj, setVehicleobj] = React.useState({events:[]});
  const carno = React.useRef();
  useEffect(async () => {
    carno.current = props.carno;
   // await get_Vehicle();
    await getoken();
    // 定時讀取車機清單
    // eslint-disable-next-line no-const-assign
    // eslint-disable-next-line react-hooks/exhaustive-deps
    intervalId = setInterval(() => {
     // get_Vehicle();
    }, 25000);
    // componentWillUnmount
    return function cleanup() {
      clearInterval(intervalId);
    };
  }, [carno,props.carno]);

  // 取得token
  // eslint-disable-next-line camelcase
  const getoken = async () => {
    await axios
      .get(`${host}/api/DVR/getdvrinfo`, {
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          token = response.data.data.token;
        } else {
          props.setreason('讀取token失敗!!');
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  // 取得動見上線車機
  // eslint-disable-next-line camelcase
  const get_Vehicle= async () => {
    await axios
      .get(`${dvrhost}realtime-monitor/vehicles?vehicle=${carno.current}`, {
        headers: {
          'content-type': 'application/json',
          Authorization: `${token}`
        }
      })
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.success == true) {
          // eslint-disable-next-line eqeqeq
          if (response.data.results.latest_acc_status == 0) {
            response.data.results.latestaccstatus = '熄火';
          }else
          {
            response.data.results.latestaccstatus = '發動中';
          }
          // eslint-disable-next-line eqeqeq
          if (response.data.results.latest_moving_status == 0) {
            response.data.results.latestmovingstatus = '停止';
          }else
          {
            response.data.results.latestmovingstatus = '移動中';
          }
           // eslint-disable-next-line eqeqeq
           if (response.data.results.latest_camera_status == 0) {
            response.data.results.latestcamerastatus = '停止';
          }else
          {
            response.data.results.latestcamerastatus = '正常';
          }
          console.log(response.data.results);
          setVehicleobj(response.data.results);
        } else {
          props.setreason('讀取車輛失敗!!');
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  return (
    <BootstrapDialog
      onClose={props.ButtonhandleClose}
      aria-labelledby="customized-dialog-title"
      open={props.Buttonopen}
      maxWidth="lg"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={props.ButtonhandleClose}>
      {props.carno}/ {Vehicleobj.station_name}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <APPlatestaccstatus title="發動狀態" state={Vehicleobj.latestaccstatus}/>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Applatestmovingstatus title="移動狀態" state={Vehicleobj.latestmovingstatus} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <APPlatestcamerastatus title="鏡頭狀態" state={Vehicleobj.latestcamerastatus} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Applatestonlinetime title="車機最後上線時間" state={Vehicleobj.latest_online_time} />
          </Grid>
          <Grid item xs={3}>
            {Vehicleobj.events.map((incident) => {
              const point = [incident.latitude, incident.longitude];
              // eslint-disable-next-line prefer-const
              return (
                <Button variant="outlined" sx={{ width: '100%' }}>
                   <Typography variant="h6" color="text.secondary">
                    {incident.event_start_time}-{incident.event}
                    </Typography>  
                </Button>
              );
            })}
          </Grid>
          <Grid item xs={9}>
            <CardMedia
              component="video"
              image="http://d3ryo024ujl60y.cloudfront.net/20220302/SYS-001CH1/not_stopped_at_stop_sign/SYS-001CH1_not_stopped_at_stop_sign_20220302_233720_20220302_233737.mp4"
              controls
            />
          </Grid>
        </Grid>
      </DialogContent>
    </BootstrapDialog>
  );
}